import React from 'react';
import {Flex, Image, Link, Text} from '@chakra-ui/react';
import Bars from "../../images/header/menu.svg";
import Profile from "../../images/header/profile.svg";
import Upload from "../../images/header/upload.svg";
import {Props} from '../../interfaces/interfaces';
import {NavLink, useRouteMatch} from "react-router-dom";

export default function Header({menuOpen, menuClosed, menuContent, openMenu, closeMenu}: Props) {
  let {url, path} = useRouteMatch();

  return (
    <Flex ml={{lg: "300px"}} justifyContent="space-between" bgColor="white" p={{base: "25px 20px", lg: "25px 40px"}}
          boxShadow="2xl">
      <Image
        boxSize="30px"
        objectFit="cover"
        src={Bars}
        display={{base: "flex", lg: "none"}}
        alt="Hamburger icon"
        onClick={openMenu}
      />
      {path === "/student"
        ? <Flex display={{base: "none", lg: "flex"}} alignItems={"center"}>
          <Image
            boxSize="30px"
            objectFit="cover"
            mr={"10px"}
            src={Upload}
            alt="upload assignment icon"
          />
          <Link as={NavLink} to={"/auth/student/course-registration"} textTransform={"capitalize"}>
            register courses
          </Link>
        </Flex> :
        <Link as={NavLink} to={"/tutor/create-course"} p={2} borderRadius={"20px"} bgColor={'brand.gold'}
              color={"brand.orange"}>Create Course
        </Link>
      }
      <Flex alignItems={"center"}>
        <Image
          boxSize="30px"
          objectFit="cover"
          mr={"12px"}
          src={Profile}
          alt="profile icon"
        />
        <Link as={NavLink}
              to={`${path.match("/student") ? "/student/profile" : path.match("/tutor") && "/tutor/profile"}`}
              textTransform={"capitalize"}>
          {path.match("/student") ? "student" : path.match("/tutor") && "teacher"}
        </Link>
      </Flex>
    </Flex>
  )
}
